








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';

import { ExpirationSettings } from '@/components/organisms/OfferFreeCoins/FormSteps';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import CalendarIcon from '@/components/icons/Calendar.vue';

import { Campaign, TDeadLineType } from '@/models/marketingCenter/freeCoins';

import eventBus from '@/utils/eventBus';
import { treatError } from '@/utils';
import DateUtils from '@/utils/DateUtils';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton,
    CalendarIcon,
    ExpirationSettings
  }
})
export default class CampaignDeadlineEditModal extends Vue {
  @Prop() readonly campaign!: Campaign;
  @Prop({ default: false }) isDetail?: boolean;

  offerFreeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();

  errors: string[] = [];
  buttonDisabled = true;
  expirationValue = this.campaign.dateLimit || '';
  expirationPlaceholderValue = '';
  expirationType: TDeadLineType = !this.campaign.dateLimit
    ? 'no-deadline'
    : 'deadline-date';

  @Watch('expirationType', { deep: true })
  enableSubmitButton() {
    this.buttonDisabled = false;
    this.removeError('deadline-date');
  }

  mounted() {
    segmentIo.modal('Free Coins/Edit expiration date');

    if (!this.campaign.dateLimit) return;

    const [date] = this.campaign.dateLimit.split('T');

    this.expirationPlaceholderValue = DateUtils.formattedDate({ date });
  }

  handleChangeExpirationValue(date: string) {
    const [compaignDate] = this.campaign.dateLimit
      ? this.campaign.dateLimit.split('T')
      : '';

    if (compaignDate !== date) this.enableSubmitButton();

    this.expirationValue = date;
    this.expirationPlaceholderValue = DateUtils.formattedDate({ date });
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  removeError(errorField: string) {
    this.errors = this.errors.filter(error => error !== errorField);
  }

  async onConfirm() {
    if (!this.campaign) return;

    const payload = this.campaign;

    if (this.expirationType === 'deadline-date' && !this.expirationValue) {
      this.errors = [...this.errors, 'deadline-date'];

      this.$notification('Fill in the expire date, please', 'error');

      return;
    }

    if (this.expirationType === 'no-deadline') payload.dateLimit = undefined;

    if (this.expirationType === 'deadline-date' && this.expirationValue) {
      const fromDate = new Date(this.expirationValue);
      const parsedDate: string = fromDate.toISOString();

      payload.dateLimit = parsedDate;
    }

    try {
      this.$showLoaderWithLocker();

      const response = await this.offerFreeCoinsService.updateOfferFreeCoin(
        this.campaign.id as string,
        payload
      );

      if (response.status !== 200) return;

      this.$notification('Campaign expire date successfully updated');
      this.onClose();

      this.$analytics({
        eventCategory: `Free Coins Campaign ${
          this.isDetail ? 'Detail' : ''
        } | Edit Expiration Settings`,
        eventAction: 'click',
        eventLabel: `Edited the campaign ${
          this.isDetail ? 'detail' : ''
        } expiration settings`
      });
    } catch (e) {
      treatError(e);
    } finally {
      this.$hideLoader();
    }
  }
}
